function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * タイムライン　モデル
 */
var TimelineInstanceModel =
/**
 * コンストラクタ
 *
 * @param sessionId 会議ID`
 */
function TimelineInstanceModel(sessionId) {
  _classCallCheck(this, TimelineInstanceModel);

  this.SessionId = sessionId;
  this.SequenceGroups = [];
  this.Sequences = [];
  this.Interactions = [];
  this.Materials = [];
  this.SavedMaterials = [];
  this.TriggerTypeList = [];
  this.ActionTypeList = [];
  this.SituationList = [];
  this.ChatBotOption = false;
  this.DataIntegrationOption = false;
};

export { TimelineInstanceModel as default };